import { Configs } from 'lib/config/Configs';
import defaults from 'lib/config/defaultConfigs';
import { createContext } from 'react';

export type ContextType = {
  configs: Configs;
  isReady: boolean;
};

export default createContext<ContextType>({
  configs: defaults,
  isReady: false,
});
